var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgI3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 292,
    height: 243,
    viewBox: "0 0 292 243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(-400.5 -2033)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Anxiety_depression_and_low_self-esteem",
    "data-name": "Anxiety, depression and low self-esteem",
    transform: "translate(546.5 2095)",
    fill: "#405968",
    fontSize: 52,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -81.276,
    y: 0
  }, "ANXIETY,"), /*#__PURE__*/React.createElement("tspan", {
    x: -118.846,
    y: 50
  }, "DEPRESSION"), /*#__PURE__*/React.createElement("tspan", {
    x: -85.982,
    y: 100
  }, "AND LOW"), /*#__PURE__*/React.createElement("tspan", {
    x: -120.328,
    y: 150
  }, "SELF-ESTEEM")), /*#__PURE__*/React.createElement("text", {
    id: "are_outcomes_of_social_isolation",
    "data-name": "are outcomes of social isolation",
    transform: "translate(546.5 2270)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -145.85,
    y: 0
  }, "ARE OUTCOMES OF SOCIAL ISOLATION")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3);
export default __webpack_public_path__ + "static/media/i3.a6b4b7db046818ce6453ea8f4db3a912.svg";
export { ForwardRef as ReactComponent };